import io from "socket.io-client";
import config from "./index";

const socket = io(config.mode == "Binance" ? config.API_URL : config.BITMART_API_URL, { transports: ["websocket"], autoConnect: false });

export { socket };